export default __webpack_public_path__ + "static/media/Email.08341837.svg";